

















///<reference path="../../types/v-tooltip.d.ts"/>
import { Tooltip } from "@/service/tooltip";
import { VPopover } from "v-tooltip";
import Vue from "vue";

interface VM {
  showTooltip: boolean;
  boundTooltipScroll$: (event: Event) => void;
  boundTooltipBodyClick$: (event: Event) => void;
  tooltipDisplayedInRange$: {
    min: number;
    max: number;
  };
  tooltipTimeoutId: number | undefined;
}

export default Vue.extend({
  name: "Tooltip",
  data(): VM {
    return {
      showTooltip: false,
      boundTooltipScroll$: (event: Event) => {},
      boundTooltipBodyClick$: (event: Event) => {},
      tooltipDisplayedInRange$: {
        min: 0,
        max: 0
      },
      tooltipTimeoutId: undefined
    };
  },
  props: {
    placement: {
      type: String,
      default: "top-start"
    },
    offset: {
      type: Number,
      default: 0
    },
    popoverClass: {
      type: String,
      default: ""
    }
  },
  components: {
    VPopover
  },
  mounted() {
    this.boundTooltipScroll$ = this._onTooltipScroll.bind(this);
    this.boundTooltipBodyClick$ = this._onBodyClick.bind(this);
    window.addEventListener("scroll", this.boundTooltipScroll$);
    window.addEventListener("click", this.boundTooltipBodyClick$);
  },
  destroyed() {
    window.removeEventListener("scroll", this.boundTooltipScroll$);
    window.removeEventListener("click", this.boundTooltipBodyClick$);
  },
  methods: {
    /**
     * Once a user scrolls passed the tooltip displayed in ranges it is automatically hidden.
     * The range is set using the method {@see _setUpScrollDisplayRange}
     * @private
     */
    _onTooltipScroll(event: Event) {
      if (
        window.scrollY < this.tooltipDisplayedInRange$.max &&
        window.scrollY > this.tooltipDisplayedInRange$.min
      ) {
        return;
      }
      this.closeTooltip();
    },

    /**
     * Method which closes the tooltip if a user clicks on the document and not on the tooltip
     * @private
     */
    _onBodyClick(event: Event) {
      if (this.$el.contains(event.target as Node)) {
        return;
      }
      this.showTooltip = false;
    },

    _setUpScrollDisplayRange() {
      this.tooltipDisplayedInRange$.min =
        window.scrollY - this.$el.clientHeight * 1.2;
      this.tooltipDisplayedInRange$.max =
        window.scrollY + this.$el.clientHeight * 1.2;
    },

    toggleTooltip() {
      if (!this.showTooltip) {
        this.openTooltip();
        return;
      }
      this.closeTooltip();
    },

    openTooltip() {
      this._setUpScrollDisplayRange();
      Tooltip.getInstance().setCurrentlyOpenedTooltip(this);

      const vPopover = <any>this.$refs.vPopover;
      this.showTooltip = true;
      vPopover.show();
      vPopover.$forceUpdate();
    },
    openTooltipDelayed(time: number = 200) {
      // Set the timeout and store its ID
      this.tooltipTimeoutId = setTimeout(() => {
        this.openTooltip();
      }, time); // Adjust the delay as needed
    },
    closeTooltipDelayed() {
      clearTimeout(this.tooltipTimeoutId);
      this.closeTooltip();
    },
    closeTooltip() {
      const vPopover = <any>this.$refs.vPopover;
      this.showTooltip = false;
      if (vPopover) {
        vPopover.hide();
        vPopover.$forceUpdate();
      }
    }
  }
});
